import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import RupeeSymbol from '../RupeeSymbol';
import './FeaturedPlan.css';
import './OtherPlans.css';
import { useAxios } from '../../../../common/api/hooks/useAxios';
import { URL } from '../../../../common/api/urls';
import { useAxiosWithAuth } from '../../../../common/api/hooks/useAxiosWithAuth';
import { DISCOUNT_CONFIG, PAYMENT_METHOD_CCAVENUE, SUBSCRIPTION_PLANS_NSE_NEW } from '../../../../common/utility/constant';
import OrderDetailPopup from '../../../../pages/dashboard/components/order_detail_popup';
import $ from 'jquery';

// Helper function to calculate discounted price
const applyDiscount = (regularPrice, discountPercentage = DISCOUNT_CONFIG.percentage) => {
  const multiplier = (100 - discountPercentage) / 100;
  return Math.round(regularPrice * multiplier);
};

// Helper function to calculate savings
const calculateSavings = (regularPrice, discountedPrice) => {
  return regularPrice - discountedPrice;
};

// Helper function to process plan pricing
const processPlanPricing = (regularPrice) => {
  const discountedPrice = applyDiscount(regularPrice);
  return {
    regular: regularPrice,
    price: discountedPrice,
    savings: calculateSavings(regularPrice, discountedPrice)
  };
};

const FeaturedPlan = () => {
  const navigate = useNavigate();
  const { cancel, responseData, error, loaded, reset, executeAPI } = useAxios();
  const [cancelOrder, responseDataOrder, errorOrder, loadedOrder, resetOrder, executeAPIOrder] = useAxiosWithAuth();
  
  const [cancelOrderDetail, responseDataOrderDetail, errorOrderDetail, loadedOrderDetail, resetOrderDetail, executeAPIOrderDetail] = useAxiosWithAuth();

  const [showorderPopup, setShowOrderPopup] = useState(false);
  const [orderDetailsData, setOrderDetailsData] = useState();
  const [planName, setPlanName] = useState("");
  const [isIndex, setIsIndex] = useState(false);
  
  const [planData, setPlanData] = useState({
    stocks: {
      quarterly: { regular: 0, price: 0, savings: 0 },
      monthly: { regular: 0, price: 0, savings: 0 },
      annually: { regular: 0, price: 0, savings: 0 }
    },
    index: {
      quarterly: { regular: 0, price: 0, savings: 0 },
      monthly: { regular: 0, price: 0, savings: 0 },
      annually: { regular: 0, price: 0, savings: 0 }
    }
  });

  useEffect(() => {
    executeAPI(URL.GET_SUBSCRIPTION_PLANS_NEW, "GET", {});
  }, []);

  useEffect(() => {
    if (loaded && responseData?.data) {
      const data = responseData.data;
      
      // Process STOCKS plans
      const stocksQuarterly = processPlanPricing(data.quarterly.elite.stocks_actual);
      const stocksMonthly = processPlanPricing(data.monthly.elite.stocks + data.monthly.elite.stocks_gst);
      const stocksAnnually = processPlanPricing(data.annually.elite.stocks_actual);

      // Process INDEX plans
      const indexQuarterly = processPlanPricing(data.quarterly.elite.base_actual);
      const indexMonthly = processPlanPricing(data.monthly.elite.base + data.monthly.elite.base_gst);
      const indexAnnually = processPlanPricing(data.annually.elite.base_actual);

      setPlanData({
        stocks: {
          quarterly: stocksQuarterly,
          monthly: stocksMonthly,
          annually: stocksAnnually
        },
        index: {
          quarterly: indexQuarterly,
          monthly: indexMonthly,
          annually: indexAnnually
        }
      });
      console.log("Plans Data:", responseData);
    } else if (error) {
      console.error("Error fetching plan data:", error);
    }
    reset();
  }, [loaded, responseData]);

  useEffect(() => {
    console.log("OrderDetails=", responseDataOrderDetail);
    if (loadedOrderDetail) {
      if (responseDataOrderDetail != null) {
        if (responseDataOrderDetail.success != undefined && responseDataOrderDetail.success == true) {
          console.log("OrderDetails 1=", responseDataOrderDetail);
          setOrderDetailsData(responseDataOrderDetail);
          setShowOrderPopup(true);
        }
      }
      resetOrderDetail();
    }
  }, [loadedOrderDetail, responseDataOrderDetail, errorOrderDetail, resetOrderDetail]);

  useEffect(() => {
    if (loadedOrder) {
      if (responseDataOrder != null) {
        if (responseDataOrder.success != undefined && responseDataOrder.success == true) {
          console.log(responseDataOrder);

          let url = 'https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction';
          if (responseDataOrder.type != undefined && responseDataOrder.type == "test") 
            url = 'https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction';
          
          let form = $('<form action="' + url + '" method="post">' +
            '<input type="hidden" id="encRequest" name="dtype" value="' + responseDataOrder.type + '">' +
            '<input type="hidden" id="encRequest" name="encRequest" value="' + responseDataOrder.encRequest + '">' +
            '<input type="hidden" name="access_code" id="access_code" value="' + responseDataOrder.access_code + '">' +
            '</form>');

          $('body').append(form);
          form.submit();
        }
      }
      resetOrder();
    }
  }, [loadedOrder, responseDataOrder, errorOrder, resetOrder]);

  const upgradeToPlan = (planType) => {
    let selectedPlan = "";

    if (planType === "monthly") {
      selectedPlan = isIndex ? SUBSCRIPTION_PLANS_NSE_NEW.ELITE_INDEX_MONTHLY_1 : SUBSCRIPTION_PLANS_NSE_NEW.ELITE_INDEX_STOCKS_MONTHLY_1;
    } else if (planType === "quarterly") {
      selectedPlan = isIndex ? SUBSCRIPTION_PLANS_NSE_NEW.ELITE_INDEX_MONTHLY_3 : SUBSCRIPTION_PLANS_NSE_NEW.ELITE_INDEX_STOCKS_MONTHLY_3;
    } else if (planType === "annually") {
      selectedPlan = isIndex ? SUBSCRIPTION_PLANS_NSE_NEW.ELITE_INDEX_MONTHLY_12 : SUBSCRIPTION_PLANS_NSE_NEW.ELITE_INDEX_STOCKS_MONTHLY_12;
    }
    setPlanName(selectedPlan);

    const data = { plan_name: selectedPlan, status_check: 1, disc_coupon: DISCOUNT_CONFIG.code, "payment_method": PAYMENT_METHOD_CCAVENUE};
    executeAPIOrderDetail(URL.SUBSCRIPTION_ORDER, "POST", data);
  };

  const continuePayment = (code, method) => {
    setShowOrderPopup(false);
    executeAPIOrder(URL.SUBSCRIPTION_ORDER, "POST", { "plan_name": planName, "status_check": 0, "disc_coupon": code, "payment_method": method })
  };

  // Get current plan data based on toggle
  const currentPlanData = isIndex ? planData.index : planData.stocks;

  const plans = [
    {
      name: '💎 Elite Annual',
      price: currentPlanData.annually.price.toLocaleString('en-IN'),
      regularPrice: `${currentPlanData.annually.regular.toLocaleString('en-IN')}/year`,
      savings: `${currentPlanData.annually.savings.toLocaleString('en-IN')} (${DISCOUNT_CONFIG.label})`,
      highlight: { value: `${Math.round(currentPlanData.annually.price / 365)}/day`, label: 'Less than a cup of coffee' },
      features: [
        '12 months Elite access',
        'Maximum savings locked',
        'All Elite features included',
        'Best for regular traders'
      ],
      type: 'annually'
    },
    {
      name: '⚡ Elite Monthly',
      price: currentPlanData.monthly.price.toLocaleString('en-IN'),
      regularPrice: `${currentPlanData.monthly.regular.toLocaleString('en-IN')}/month`,
      savings: `${currentPlanData.monthly.savings.toLocaleString('en-IN')} (${DISCOUNT_CONFIG.label})`,
      highlight: { value: `${Math.round(currentPlanData.monthly.price / 30)}/day`, label: 'Less than a cup of coffee' },
      features: [
        'Month-to-month flexibility',
        'Test Elite further',
        'All Elite features included',
        'Upgrade to annual anytime'
      ],
      type: 'monthly'
    }
  ];

  return (
    <>
      {/* Toggle Button Section */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        padding: '20px 0',
        marginTop: '20px'
      }}>
        <motion.div
          style={{
            display: 'inline-flex',
            backgroundColor: '#1a1a2e',
            borderRadius: '50px',
            padding: '6px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
            border: '1px solid rgba(255,255,255,0.1)'
          }}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <motion.button
            onClick={() => setIsIndex(false)}
            style={{
              padding: '12px 32px',
              borderRadius: '50px',
              border: 'none',
              backgroundColor: !isIndex ? '#4CAF50' : 'transparent',
              color: !isIndex ? '#fff' : 'rgba(255,255,255,0.6)',
              fontWeight: '600',
              fontSize: '16px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              position: 'relative',
              zIndex: 1
            }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            📈 All F&O
          </motion.button>
          <motion.button
            onClick={() => setIsIndex(true)}
            style={{
              padding: '12px 32px',
              borderRadius: '50px',
              border: 'none',
              backgroundColor: isIndex ? '#4CAF50' : 'transparent',
              color: isIndex ? '#fff' : 'rgba(255,255,255,0.6)',
              fontWeight: '600',
              fontSize: '16px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              position: 'relative',
              zIndex: 1
            }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            📊 Index-only
          </motion.button>
        </motion.div>
      </div>

      <section className="featured-plan-section">
        <div className="container">
          <motion.div
            className="featured-plan"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            key={isIndex ? 'index' : 'stocks'} // Re-animate on toggle
          >
            <div className="featured-badge">
              🔥 &nbsp;MOST POPULAR - BEST VALUE {isIndex ? '(INDEX)' : '(STOCKS)'}
            </div>
            <h2>Elite Quarterly + FREE eCourse</h2>
            <p className="featured-plan-description">
              Get Elite tools + professional trading education together
            </p>

            <div className="featured-plan-details">
              <div className="featured-price-box">
                <div className="featured-price-label">Elite Quarterly Plan</div>
                <div className="featured-regular-price">
                  Regular: <RupeeSymbol />{currentPlanData.quarterly.regular.toLocaleString('en-IN')}
                </div>
                <div className="featured-demo-price">
                  <RupeeSymbol />{currentPlanData.quarterly.price.toLocaleString('en-IN')}
                </div>
                <div className="featured-savings">
                  Save <RupeeSymbol />{currentPlanData.quarterly.savings.toLocaleString('en-IN')} ({DISCOUNT_CONFIG.label})
                </div>
              </div>

              <div className="featured-bonus-box">
                <div className="bonus-label">🎁 EXCLUSIVE BONUS</div>
                <div className="bonus-value">FREE</div>
                <div className="bonus-item">Complete eCourse</div>
                <div className="bonus-regular-value">Regular Value: <RupeeSymbol />3,539</div>
              </div>
            </div>

            <div className="total-value">
              <div className="total-value-text">
                Total Package Value: <RupeeSymbol />{(currentPlanData.quarterly.regular + 3539).toLocaleString('en-IN')}
              </div>
              <div className="total-value-pay">
                You Pay Only: <RupeeSymbol />{currentPlanData.quarterly.price.toLocaleString('en-IN')}
              </div>
              <div className="total-value-savings">
                Total Savings: <RupeeSymbol />{(currentPlanData.quarterly.savings + 3539).toLocaleString('en-IN')}
              </div>
            </div>

            <div className="featured-features-box">
              <h3>What You Get:</h3>
              <div className="features-grid">
                <div>✅ 3 Months Elite Access</div>
                <div>✅ Live NSE Data Feed</div>
                <div>✅ Order Flow Analysis</div>
                <div>✅ Market Profile Charts</div>
                <div>✅ Institutional Tracking</div>
                <div>✅ COT Volume & Footprints</div>
                <div>✅ Complete eCourse (FREE)</div>
                <div>✅ Professional Strategies</div>
              </div>
            </div>

            <motion.button
              className="cta-button cta-button-featured"
              onClick={() => upgradeToPlan('quarterly')}
              whileHover={{ scale: 1.02, y: -2 }}
              whileTap={{ scale: 0.98 }}
            >
              Get Quarterly + Free eCourse - Use {DISCOUNT_CONFIG.code}
            </motion.button>

            <div className="code-reminder">
              Enter code <strong>{DISCOUNT_CONFIG.code}</strong> at checkout for {DISCOUNT_CONFIG.percentage}% discount + free eCourse
            </div>
          </motion.div>
        </div>
      </section>

      <section className="other-plans-section">
        <div className="container">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Or Choose Another Elite Plan
          </motion.h2>

          <motion.p
            className="section-subtitle"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            All plans include {DISCOUNT_CONFIG.label} with code {DISCOUNT_CONFIG.code}
          </motion.p>

          <div className="plan-options">
            {plans.map((plan, index) => (
              <motion.div
                key={`${plan.type}-${isIndex ? 'index' : 'stocks'}`}
                className="plan-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
                whileHover={{ y: -5 }}
                onClick={() => upgradeToPlan(plan.type)}
              >
                <div className="plan-name">{plan.name}</div>
                <div className="plan-price"><RupeeSymbol />{plan.price}</div>
                <div className="plan-regular"><RupeeSymbol />{plan.regularPrice}</div>
                <div className="plan-save">Save <RupeeSymbol />{plan.savings}</div>

                <div className="plan-highlight">
                  <div className="highlight-value">
                    <RupeeSymbol />{plan.highlight.value}
                  </div>
                  <div className="highlight-label">{plan.highlight.label}</div>
                </div>

                <ul className="plan-features">
                  {plan.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>

                <motion.button
                  className="cta-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    upgradeToPlan(plan.type);
                  }}
                  whileHover={{ scale: 1.02, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                >
                  Upgrade {plan.type === 'annually' ? 'Annual' : 'Monthly'} - Use {DISCOUNT_CONFIG.code}
                </motion.button>

                <div className="code-reminder">{DISCOUNT_CONFIG.label} with code {DISCOUNT_CONFIG.code}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {showorderPopup && (
        <OrderDetailPopup
          data={orderDetailsData}
          planName={planName}
          onProceed={continuePayment}
          onCancel={() => setShowOrderPopup(false)} />
      )}
    </>
  );
};

export default FeaturedPlan;